import React, { useContext } from "react";
import { Typography } from "@mui/material";
import { ErrorMessage, FastField, Field } from "formik";
import TextError from "../TextError";
import useFormikTextArea from "./useFormikTextArea";
import FormikControlContext from "../../../Contexts/FormikControlContext";

const FormikTextArea = () => {
  const field = useContext(FormikControlContext);
  const { label, name, validation, readOnly } = field;

  const { handleChange, handleBlur } = useFormikTextArea();

  const TextAreaField = readOnly === undefined ? Field : FastField;

  return (
    <div>
      <Typography>
        {label}
        {validation?.required && <span>*</span>}
      </Typography>

      <TextAreaField
        as="textarea"
        label={label}
        id={name}
        name={name}
        placeholder={label}
        onChange={(e) => handleChange(name, e)}
        onBlur={(e) => handleBlur(name, e)}
        required={validation?.required ?? false}
      />

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikTextArea;
